import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Button } from '@framework/ui/atoms/Button';
import { Loading } from '@framework/ui/atoms/Loading';
import { Link } from 'react-router';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { FirebaseAuthenticationClient } from '@framework/firebase/auth';
import { toast } from 'react-hot-toast';
import { randInt } from '@framework/index';
import { trpcClient } from '@framework/trpcClient';
type Props = {
  isOpen: boolean;
  onClose(): void;
  title?: string;
  shouldCloseOnOverlayClick?: boolean;
};
export const LoginModal: React.FC<Props> = ({ isOpen, onClose, title, shouldCloseOnOverlayClick }: Props) => {
  const { t } = useTranslation();
  const animalNames = t('framework.login.animalNames', { returnObjects: true }) as unknown as string[];
  const [processing, setProcessing] = useState<boolean>(false);
  const [name, setName] = useState<string>(animalNames[randInt(animalNames.length - 1)]);

  const handleClickAnonymousLogin = () => {
    if (name.trim() === '') return;

    setProcessing(true);

    trpcClient.anonymousUser.signIn
      .mutate({ name: name.trim() })
      .then(async ({ token }) => {
        await FirebaseAuthenticationClient.signInWithCustomToken(token);
      })
      .catch((error) => {
        toast.error(t('framework.login.processError'));
        console.error(error);
      })
      .finally(() => setProcessing(false));
  };

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={onClose}
      title={title || t('framework.login.title')}
      submitButton={<></>}
      cancelButton={<></>}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <div className="flex flex-col items-center justify-center p-4" style={{ width: '600px' }}>
        {processing ? (
          <Loading horizontal={true} />
        ) : (
          <>
            <div className="py-2 text-center text-lg font-bold">{t('framework.login.guestEntry')}</div>
            <div className="w-80 py-2 text-lg">
              <input
                type="text"
                className="w-full rounded border px-3 py-2"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>
            <Button color="brand" onClick={handleClickAnonymousLogin} disabled={name === ''}>
              <div className="px-2">{t('framework.login.start')}</div>
            </Button>

            <div className="py-4 text-center text-base hover:underline">
              <Link to={UserPagePathBuilder.loginPage(window.location.pathname + window.location.search)}>
                {t('framework.login.title')}
              </Link>
            </div>
          </>
        )}
      </div>
    </GeneralModal>
  );
};
